import React from 'react'

import { useParams } from 'react-router-dom'

const mapUrlToPageLogProps = fn => Component => () => {
  const params = useParams()
  const props = fn({ params })

  return <Component subtitle="Logs" {...props} />
}

export default mapUrlToPageLogProps
